import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { ICompanySchemaPartial, ICompanySchema } from '../../type/company';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';
import { ICountrySchema } from '../../type/country';


export interface ICompanyQuerySearchInfo {
  searchInfo: {
    countryInfos: {
      key: string
      country?: ICountrySchema
      count: number
      alphabetGroupByCountryInfo: {
        key: string
        count: number
      }[]
    }[]
    groupByAlphabetInfo: {
      key: string
      count: number
    }[];
  };
}



export interface ICompanyVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  active?: boolean;
  status?: boolean;
  verification?: boolean;
  origin?: string;
  matchAnyOrigins?: string[];
  slug?: string;
  subdirectoryTags?: string[];
  isEnableDropshipping?: boolean;
  matchAnyClassificationSlug?: string[];
  matchAnyBrandSlug?: string[];
}
 sort: {
  _id?: number;
  createdTime?: number;
  updatedTime?: number;
  logoStatus?: number;
}
 search: {
  _id?: string;
  name?: string;
  nameStartWith?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  useSearch: boolean
  
 
}
export const CompanyQueryTypeDefinitionKey = 'Company';
export type ICompanyVarsPartial = Partial<ICompanyVars>
export type ICompanyDataPartial = DeepPartial<ICompanySchemaPartial>
export interface ICompanyQueryData<TData extends ICompanySchema = ICompanySchema>{
  

    companies: IWithPagination<TData> & ICompanyQuerySearchInfo
}

export function companyQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    companies(
        $filter: CompanyQueryFilterParameterInput,
$search: CompanyQuerySearchParameterInput,
$sort: CompanyQuerySortParameterInput,
$skip: Int,
$limit: Int,
$useSearch: Boolean
        ){
        

    companies(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit,
useSearch: $useSearch
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function useCompanyLazyQuery<TData extends ICompanySchema>(
  fragment: string,
  options?: QueryHookOptions<ICompanyQueryData<TData>, ICompanyVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<ICompanyQueryData<TData>, ICompanyVarsPartial>(companyQuery(fragment, rootFragment, withPagination), options);
}

export function useCompanyQuery<TData extends ICompanySchema>(
  fragment: string,
  options?: QueryHookOptions<ICompanyQueryData<TData>, ICompanyVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<ICompanyQueryData<TData>, ICompanyVarsPartial>(companyQuery(fragment, rootFragment, withPagination), options);
}
